import { PageEvent } from '@angular/material/paginator';
import { Sort } from '@angular/material/sort';
import { BehaviorSubject } from 'rxjs';
import { DiscountType } from 'src/app/shared/enums/discount-type.enum';
import { IdTagStatusEnum } from 'src/app/shared/enums/id-tag-status.enum';
import { IdTagTypeEnum } from 'src/app/shared/enums/id-tag-type.enum';
import { IdTagUserType } from 'src/app/shared/enums/id-tag-user-type.enum';

export class IdTag {
  id: number;
  activeFrom: Date;
  activeTo: Date;
  active: boolean;
  organizationId: number;
  departmentId: number;
  chargingUserDepartmentId: number;
  departmentName: string;
  chargingUserDepartmentName: string;
  organizationName: string;
  status: IdTagStatusEnum;
  created: Date;
  createdBy: string;
  updated: Date;
  updatedBy: string;
  printedId: number;
  idToken: string;
  description: string;
  checked: boolean;
  externalIdentifier: string;
  highlight: BehaviorSubject<boolean>;
  shippingAddress: string;
  darId?: string;
  externalReference: string;
  attention: string;
  chargingUserId: number;
  idTagType: IdTagTypeEnum;
  idTagUserType: IdTagUserType;
  deleted: boolean;
  idTagIdentifier: string;
  paymentInfo?: number;
  accessGroupIdentifiers: string[];
  agreementNumber: number | null;
}

export class LookupIdTag {
  printedId: number;
  idToken: string;
  idTagIdentifier: string;
  used: boolean;
}

export class IdTagSearchEvent {
  constructor(paging: PageEvent) {
    this.paging = paging;
    this.sorting = null;
    this.excludedAccessGroupIdentifier = null;
  }
  organizationId?: number;
  departmentId?: number;
  printedId?: number;
  query?: string | null;
  chargingUserId?: number;
  status?: IdTagStatusEnum;
  idTagType?: IdTagTypeEnum;
  includeInactive?: boolean = true;
  paging: PageEvent;
  sorting: Sort | null;
  idTagUserType?: IdTagUserType;
  excludedAccessGroupIdentifier?: string | null;
}

export class AccessGroupIdTagsSearchEvent {
  constructor(paging: PageEvent) {
    this.paging = paging;
    this.sorting = null;
  }
  idTagId?: number;
  paging: PageEvent;
  sorting?: Sort | null;
  includeDeleted?: boolean;
}

export interface AccessGroupIdTag {
  accessGroupIdentifier: string;
  idTagId: number | null;
  name: string;
  amount: number;
  discountType: DiscountType;
  deleted?: string;
}
